import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { create } from 'braintree-web/client';
import { create as dataCollectorCreate } from 'braintree-web/data-collector';
import { Processors } from '../../../constants/AppConstants';
import { Component } from '../../../constants/CallbackConstants';
import { ErrorType } from '../../../constants/Errors';
import { SharedCommandNames, StatusTypes } from '@chegg/commerce-utils';
import { doFireStatusUpdate } from '../../../utils/CallbackUtils';
import { sendNewRelicMessage } from '../../../utils/NewRelicUtils';
var BraintreeService = /*#__PURE__*/function () {
  function BraintreeService(params) {
    _classCallCheck(this, BraintreeService);
    _defineProperty(this, "type", Processors.BRAINTREE);
    _defineProperty(this, "dispatch", void 0);
    _defineProperty(this, "clientInstance", null);
    _defineProperty(this, "dataCollectorInstance", null);
    this.dispatch = params.dispatch;
    this.initialize(params);
  }
  return _createClass(BraintreeService, [{
    key: "initialize",
    value: function initialize(params) {
      var _this = this;
      var callback = params.callback,
        authorization = params.authorization,
        dataCollectorCallback = params.dataCollectorCallback;
      if (this.clientInstance) return;
      create({
        authorization: authorization
      }, function (createErr, clientInstance) {
        if (createErr) {
          doFireStatusUpdate([{
            status: StatusTypes.ERROR,
            command: SharedCommandNames.INITIALIZE,
            payload: {
              component: Component.BRAINTREE_SERVICE,
              errors: [{
                code: createErr.code,
                message: createErr.message,
                type: ErrorType.SERVER
              }]
            }
          }]);
          sendNewRelicMessage('Unable to initialize Braintree Client instance', {
            errors: JSON.stringify(createErr)
          });
        } else {
          _this.clientInstance = clientInstance;
          callback(_this);
          dataCollectorCreate({
            client: clientInstance,
            kount: true,
            paypal: true
          }, function (dataCollectorErr, dataCollectorInstance) {
            if (dataCollectorErr) {
              sendNewRelicMessage('Unable to initialize Braintree Data collector instance', {
                errors: JSON.stringify(dataCollectorErr)
              });
              dataCollectorCallback('');
            } else {
              _this.dataCollectorInstance = dataCollectorInstance;
              dataCollectorCallback(dataCollectorInstance.deviceData);
            }
          });
        }
      });
    }
  }]);
}();
export { BraintreeService as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/business/processors/braintree/BraintreeService.js
// module id = 4582
// module chunks = 11